<template>
  <v-img contain height="18px" width="18px" src="@/assets/google_logo.png"></v-img>
</template>

<script>
export default {
  name: 'ImageIcon'
//   props: {
//     imgsrc: String
//   }
}
</script>
